import { useSelector } from 'react-redux'
import { State } from 'src/state'
import { CurrencyCode } from '@meniudigital/shared'
import CurrencyToggle from './CurrencyToggle'
import Setting from '../Setting'

export default function CurrencySetting() {
  const { user } = useSelector((state: State) => state.users)

  if (!user) {
    return null
  }

  return (
    <Setting
      title="Monedă Meniu"
      iconPath="/icons/currency.png"
      rightButton={<CurrencyToggle />}
      infoText={`Monedă în care vei introduce prețul produselor: ${(user?.defaultCurrency || CurrencyCode.Ron).toUpperCase()}`}
    />
  )
}
